import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StepWrapper = styled(Box)(() => ({
  textAlign: 'center',
  padding: '1.75rem',
}));

export const TextBox = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
  paddingBottom: '2rem',
}));

export const IconWrapper = styled('img')(() => ({
  width: '9rem',
  height: '9rem',
  marginBottom: '1.5rem',
  paddingTop: '1rem',
}));

export const ButtonLink = styled(Button)(() => ({
  
}));

export const ButtomWrapper = styled('div')(() => ({
    width:'100%',
    display:'flex',
    justifyContent:'center'
}));
